module.exports = __webpack_public_path__ + "img/medkit.04a4db89.svg";